import React from "react";

/**
 * Refined typographic wordmark - elegant champagne grad, no monogram circle.
 */
const Logo = ({ size = "md", className = "" }) => {
    const sizes = {
        sm: { name: "text-sm md:text-base", sub: "text-[9px]" },
        md: { name: "text-lg md:text-xl", sub: "text-[10px]" },
        lg: { name: "text-2xl md:text-3xl", sub: "text-[11px]" },
    };
    const s = sizes[size] || sizes.md;

    return (
        <div className={`flex flex-col leading-none ${className}`} data-testid="brand-logo">
            <span
                className={`font-display italic text-champagne-grad ${s.name}`}
                style={{ fontWeight: 500, letterSpacing: "0.01em" }}
            >
                Gilles Delieuze
            </span>
            <span
                className={`mt-1.5 ${s.sub} text-ivory/55 font-mono-tracked`}
                style={{ letterSpacing: "0.45em" }}
            >
                Portail
            </span>
        </div>
    );
};

export default Logo;
